module.exports = {
    COMPETITION_ENTITY_STATUS_CREATED: 0,
    COMPETITION_ENTITY_STATUS_IN_PROGRESS: 1,
    COMPETITION_ENTITY_STATUS_PROCESSED: 2,
    COMPETITION_ENTITY_REPORT_STATUS_CREATED: 0,
    COMPETITION_ENTITY_REPORT_STATUS_IN_PROGRESS: 1,
    COMPETITION_ENTITY_REPORT_STATUS_PROCESSED: 2,
};
